export default __webpack_public_path__ + "static/media/spinach-fetuccinii.f6a54113.jpg";